import * as THREE from 'three'

export default function createLights({ scene })
{
  const directionalLight = new THREE.DirectionalLight('#ffffff', 3)
  directionalLight.castShadow = true
  directionalLight.shadow.mapSize.set(1024, 1024)
  directionalLight.shadow.camera.far = 15
  directionalLight.shadow.normalBias = 0.05
  directionalLight.position.set(-0.75, 1, -2.25)

  scene.add(directionalLight)

  return { directionalLight }
}
